import {configureStore} from '@reduxjs/toolkit';

import {topTrailerReducer} from './slices/topTrailer.slice'
import {topNewsReducer} from './slices/news.slice'
import {movieReducer} from './slices/movie.slice'
import {trailerReducer} from './slices/trailer.slice'
import {actressReducer} from './slices/actress.slice'
import {actorReducer} from './slices/actor.slice'
import {galleryReducer} from './slices/gallery.slice'
import {reviewReducer} from './slices/review.slice'

export const store = configureStore({
  reducer: {
    topTrailer: topTrailerReducer,
    news: topNewsReducer,
    movie: movieReducer,
    trailer: trailerReducer,
    actress: actressReducer,
    actor: actorReducer,
    gallery: galleryReducer,
    review: reviewReducer,
  },
});